export default "__VITE_ASSET__Oz4HeYG6__"